import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNG } from 'primeng/config';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
    title = 'Innov';
    AVAILABLE_LANGS = ['fr', 'en'];

    constructor(public translate: TranslateService, private config: PrimeNG) {}

    ngOnInit() {
        this.updatePrimeNGTranslation();
        this.translate.onLangChange.subscribe(() => {
            this.updatePrimeNGTranslation();
        });
    }

    private updatePrimeNGTranslation() {
        this.translate.get('primeng').subscribe(res => {
            this.config.setTranslation(res);
        });
    }
}
